import type { TripItineraryData } from 'tripPlanner/api/types'
import type { DegradedSurfaceIdentity } from 'tripPlanner/assistant/api/surfaceSnapshotContract'

// Format confirmed against a real svc-trip fixture (assistantSurfaceProtocolFixtures.js:
// surfaceContextScopeKey: 'trip:123' for chatId: 123), not invented -- and `trip`/`trip-chat`
// are already in svc-trip's registeredSemanticIdPrefixes allowlist.
export function buildTripPlannerSnapshotScopeKey(chatId: number): string {
  return `trip:${chatId}`
}

export function buildTripPlannerDegradedIdentity({
  chatId,
  itineraryData,
}: {
  chatId: number
  itineraryData: TripItineraryData | undefined
}): DegradedSurfaceIdentity {
  return {
    surface: 'trip_planner',
    surfaceContextScopeKey: buildTripPlannerSnapshotScopeKey(chatId),
    tripId: itineraryData ? String(itineraryData.tripChatId) : String(chatId),
  }
}
